package presentation.screens.customer.product_category_details

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import component.navigation.TopNavBar
import component.product.ProductListForCategory
import feature.productCategory.viewModel.ProductCategoryViewModel

class ProductCategoryDetailsScree : Screen {

    var viewModel: ProductCategoryViewModel? = null

    @Composable
    override fun Content() {
        Column {
            TopNavBar("", { })
            if (viewModel != null) {
                ProductListForCategory(onClick = {

                }, onClickProduct = {

                }, viewModel = viewModel!!)
            }
        }
    }
}